
import { z } from "zod";
import { User } from "../User";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";

const _UserZod = z.object({
  id: z.string().optional().default(""),
  firstName: z.string().optional().default(""),
  lastName: z.string().optional().default(""),
  username: z.email().optional().default(""),
  emails: z.array(z.email()).optional().default([]),
  organisation: z.string().optional().default(""),
})

// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _UserZod, User>);
export const UserSchema = _UserZod.transform((data) => new User(data));


